import { FC } from "react";
import { Configuration } from "Configuration/Configuration";

export const Start: FC = () => {
    const configuration = Configuration.get();
    location.href = `${configuration.authUrl}/?appId=${configuration.authAppId}`;
    return null;
};